const VALIDATOR_NAME = 'name';
const VALIDATOR_AMADEUS_NAME = 'name-amadeus';

export default function NameValidator(
    tripDetailsService
) {
    'ngInject';

        return {
            restrict: 'A',
            require: 'ngModel',
            scope: {
                tripDetails: '=?ktNameValidator',
            },
            link: function($scope, elem, attrs, ngModelCtrl) {
                ngModelCtrl.$parsers.unshift(validator);

                function validateNameWithSeveralWords(viewValue) {
                    const regexp = /^[a-z\-]*([\s][a-z\-]+)*$/i;
                    const isValid = regexp.test(viewValue);
                    ngModelCtrl.$setValidity(VALIDATOR_NAME, isValid);
                    return isValid;
                }

                function validator(viewValue) {
                    const containsAmadeusItem = tripDetailsService.doesTripContainAmadeusItem($scope.tripDetails);

                    if (containsAmadeusItem) {
                        validateForAmadeus(viewValue);
                    } else {
                        validateNameWithSeveralWords(viewValue);
                    }

                    return viewValue;
                }

                function validateForAmadeus(viewValue) {
                    if (!validateNameWithSeveralWords(viewValue)) {
                        return false;
                    }

                    const pattern = /[^a-z0-9]+/ig;
                    const isValid = viewValue.replace(pattern, ' ').trim().length >= 2;
                    ngModelCtrl.$setValidity(VALIDATOR_AMADEUS_NAME, isValid);
                    return isValid;
                }
            },
        };
}



// WEBPACK FOOTER //
// ./src/app/directives/ktNameValidator.js